import {
    getProjectCostByIdAxios,
    createProjectCostAxios,
    deleteProjectCostAxios,
    updateProjectCostAxios 
  } from "./services";
  
  export async function fetchProjectCosts({ commit }, projectCostId) {
    commit("LOADING_PROJECT_COST", true);
    try {
      const { data } = await getProjectCostByIdAxios(projectCostId);
      commit("SET_SINGLE_PROJECT_COST", data.result); // Use mutation to set the fetched cost
    } catch (error) {
      console.error("Error fetching project costs:", error);
      throw error;
    } finally {
      commit("LOADING_PROJECT_COST", false);
    }
  }
  
  export async function createProjectCost({ commit }, cost) {
    try {
      const { data } = await createProjectCostAxios(cost);
      commit("ADD_PROJECT_COST", data);
    } catch (e) {
      console.error("Error creating project cost:", e);
      throw e;
    }
  }
  
  export async function deleteProjectCost({ commit }, projectCostId) {
    try {
      await deleteProjectCostAxios(projectCostId);
      commit("REMOVE_PROJECT_COST", projectCostId);
    } catch (e) {
      console.error("Error deleting project cost:", e);
      throw e;
    }
  }
  
  export async function updateProjectCost({ commit }, cost) {
    try {
      const { data } = await updateProjectCostAxios(cost);
      commit("SET_SINGLE_PROJECT_COST", data); // Update the state with the updated cost
    } catch (e) {
      console.error("Error updating project cost:", e);
      throw e;
    }
  }